import { END_LOADING, START_LOADING } from "../actions/LoadingActions";

const initialState = {
    loading: false
}

export default function loadingReducer(state = initialState, action) {
    
    const nextState = Object.assign({}, state);

    switch(action.type) {
        case START_LOADING:
            nextState.loading = true;
            return nextState;
        case END_LOADING:
            nextState.loading = false;
            return nextState;
        default:
            return nextState;
    }
};
